var ready = function(fn) {
	// Sanity check
	if (typeof fn !== 'function') return;

	// If document is already loaded, run method
	if (
		document.readyState === 'interactive' ||
		document.readyState === 'complete'
	) {
		return fn();
	}

	// Otherwise, wait until document is loaded
	document.addEventListener('DOMContentLoaded', fn, false);
};

// events on load
ready(function() {
	svg4everybody();
	observerInit();
	lazyloadInit();
	modalInit();
	fixedHeaderInit();
	scrollDetect();

	headerSearchInit();
	headerTogglerInit();
	shapeRatioInit();
	detailTogglerInit();
	indexHeroInit();

	categorySliderInit();
	aboutGallerySliderInit();

	subcategoryAsideInit();
	readMoreInit();

	getHeaderHeight();
	screenNavInit();

	contactsFormBtn();
	vacancyFormBtn();

	productIconsQtyDetect();
	productControlsQtyDetect();
	observerOverlayInit();
	overlayInit();

	productSliderInit();
	screenSliderInit();
	getFileName();
});

// events on scroll
$(window).scroll(function() {});

// events on resize
window.onresize = function() {
	getHeaderHeight();
	screenNavInit();
};

// events on click
$(document).on('click', function(e) {});
